import { httpStatusCode } from "../../config/constants";
import { AppDispatch } from "../../reducers";
import {
  executeBaseRequestsFail,
  executeBaseRequestsSuccess,
  setDisplayMainAppError,
  startExecuteBaseRequests
} from "../../store/appStatus";
import { exists, getErrorMessageFromRequest } from "../../utils/utils";
import {
  getUsers,
  getOrganizationsRoles,
  getPermissions,
  getFineGrainedPermissions,
  getLimitsAndAccounting,
  getPencilerStartProjectsStatus,
  refreshOrganization,
  getAdministrators
} from "../accounts/accounts";
import {
  getAclList,
  getUserTypes,
  getAvailableRegions,
  getAvailableRoles,
  getUserSettings
} from "../users/users";

/**
 * Execute app base requests.
 * This means that without these requests' responses the app can't be
 * initialized correctly.
 */
export const executeBaseRequests = () => (dispatch: AppDispatch) => {
  // Promise.all is used instead of a single promise in order to support upcoming
  // multiple requests without needing to refactor.
  dispatch(startExecuteBaseRequests());
  Promise.all([
    dispatch(getAvailableRegions()),
    dispatch(getAvailableRoles()),
    dispatch(getAclList()),
    dispatch(getLimitsAndAccounting()),
    dispatch(getPencilerStartProjectsStatus()),
    dispatch(getUsers()),
    dispatch(getUserTypes()),
    dispatch(getUserSettings()),
    dispatch(refreshOrganization()),
    dispatch(getOrganizationsRoles()),
    dispatch(getPermissions()),
    dispatch(getAdministrators()),
    dispatch(getFineGrainedPermissions())
  ])
    .then(() => dispatch(executeBaseRequestsSuccess()))
    .catch(error => {
      let message = getErrorMessageFromRequest(error);
      if (exists(error.response) && error.response.status === httpStatusCode.notFound) {
        message = "Error while sending base App requests";
      }
      dispatch(executeBaseRequestsFail(message));
      dispatch(setDisplayMainAppError({ displayMainAppError: true, message }));
    });
};
